import type { ReportLanguage } from '../../types';
import type { KatalogSprache } from './typen';

/**
 * Sprache des Mängelkatalogs aus der Berichtssprache (englische Fassung,
 * 28.09.): Englisch nur bei rein englischen Berichten — sie werden schon bei
 * der Eingabe englisch verfasst. 'de' und 'de/en' erfassen deutsch (die
 * PDF-Übersetzung ergänzt bei 'de/en' das Englische).
 */
export function katalogSprache(language: ReportLanguage | null | undefined): KatalogSprache {
    return language === 'en' ? 'en' : 'de';
}
